"use client"

import { useState, useRef, useEffect } from "react"
import Head from "./Head"
import "./header.css"
import Login from '../../login/login.jsx'
import EnquiryModal from '../../login/EnquiryModal.jsx'


const Header = () => {
  const [click, setClick] = useState(false)
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [activeSubDropdown, setActiveSubDropdown] = useState(null)

  // Login modal states
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [isSignupOpen, setIsSignupOpen] = useState(false)
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false)
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false)

  // Close dropdowns when clicking outside
  const navRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setActiveDropdown(null)
        setActiveSubDropdown(null)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  // Toggle dropdown on mobile
  const toggleDropdown = (index, e) => {
    e.preventDefault()
    if (window.innerWidth <= 768) {
      setActiveDropdown(activeDropdown === index ? null : index)
    }
  }

  // Toggle sub-dropdown on mobile
  const toggleSubDropdown = (index, e) => {
    e.preventDefault()
    e.stopPropagation()
    if (window.innerWidth <= 768) {
      setActiveSubDropdown(activeSubDropdown === index ? null : index)
    }
  }

  // Modal control functions
  const openLogin = () => setIsLoginOpen(true)
  const closeLogin = () => setIsLoginOpen(false)
  const openSignup = () => setIsSignupOpen(true)
  const closeSignup = () => setIsSignupOpen(false)
  const openForgotPassword = () => setIsForgotPasswordOpen(true)
  const closeForgotPassword = () => setIsForgotPasswordOpen(false)
  const openEnquiry = () => setIsEnquiryOpen(true)
  const closeEnquiry = () => setIsEnquiryOpen(false)

  // Handle login success
  const handleLoginSuccess = (userData) => {
    console.log("Login successful:", userData)
  }

  // Sample dropdown data with flaticon URLs
  const destinations = [
    { name: "UK", icon: "https://cdn-icons-png.flaticon.com/128/197/197374.png", id: "united-kingdom" },
    { name: "USA", icon: "https://cdn-icons-png.flaticon.com/128/197/197484.png" },
    { name: "Ireland", icon: "https://cdn-icons-png.flaticon.com/128/197/197567.png" },
    { name: "Canada", icon: "https://cdn-icons-png.flaticon.com/128/197/197430.png" },
    { name: "Germany", icon: "https://cdn-icons-png.flaticon.com/128/197/197571.png" },
    { name: "Dubai", icon: "https://cdn-icons-png.flaticon.com/128/197/197558.png" },
    { name: "France", icon: "https://cdn-icons-png.flaticon.com/128/197/197560.png" },
    { name: "Europe", icon: "https://cdn-icons-png.flaticon.com/128/197/197615.png" },
    { name: "Italy", icon: "https://cdn-icons-png.flaticon.com/128/197/197626.png" },
    { name: "Netherlands", icon: "https://cdn-icons-png.flaticon.com/128/197/197441.png" },
    { name: "Poland", icon: "https://cdn-icons-png.flaticon.com/128/197/197529.png" },
    { name: "Spain", icon: "https://cdn-icons-png.flaticon.com/128/197/197593.png" },
    { name: "Australia", icon: "https://cdn-icons-png.flaticon.com/128/197/197507.png" },
    { name: "New Zealand", icon: "https://cdn-icons-png.flaticon.com/128/197/197589.png" },
  ]

  // Education dropdown data with sub-menus
  const educationItems = [
    {
      title: "University Course",
      icon: "🎓",
      link: "/education/university",
      subItems: [
        { title: "Undergraduate", link: "/education/university/undergraduate" },
        { title: "Postgraduate", link: "/education/university/postgraduate" },
        { title: "PhD Programs", link: "/education/university/phd" },
      ],
    },
    {
      title: "SKP",
      icon: "📚",
      link: "/education/skp",
      subItems: [
        { title: "Foundation Course", link: "/education/skp/foundation" },
        { title: "Diploma Programs", link: "/education/skp/diploma" },
        { title: "Certificate Courses", link: "/education/skp/certificate" },
      ],
    },
    {
      title: "LANGUAGES",
      icon: "🗣️",
      link: "/education/languages",
      subItems: [
        { title: "English", link: "/education/languages/english" },
        { title: "French", link: "/education/languages/french" },
        { title: "German", link: "/education/languages/german" },
        { title: "Spanish", link: "/education/languages/spanish" },
      ],
    },
    {
      title: "IELTS",
      icon: "📝",
      link: "/education/ielts",
      subItems: [
        { title: "IELTS Academic", link: "/education/ielts/academic" },
        { title: "IELTS General", link: "/education/ielts/general" },
        { title: "IELTS Preparation", link: "/education/ielts/preparation" },
      ],
    },
  ]

  // Other Services dropdown data
  const servicesItems = [
    { title: "Visa Assistance", icon: "📋", link: "/services/visa" },
    { title: "Accommodation", icon: "🏠", link: "/services/accommodation" },
    { title: "Career Counseling", icon: "💼", link: "/services/career" },
    { title: "Test Preparation", icon: "📝", link: "/services/test-prep" },
    { title: "Document Verification", icon: "📄", link: "/services/documents" },
    { title: "Travel Insurance", icon: "✈️", link: "/services/insurance" },
  ]

  return (
    <>
      
      <header>
        <nav className="flexSB" ref={navRef}>
          <ul className={click ? "mobile-nav" : "flexSB "}>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/courses">All Courses</a>
            </li>
            <li>
              <a href="/about">About</a>
            </li>
            <li className="dropdown-container education-dropdown">
              <a
                href="/education"
                onClick={(e) => toggleDropdown(0, e)}
                className={activeDropdown === 0 ? "active" : ""}
              >
                Education
                <span className="dropdown-arrow">→</span>
              </a>
              <div className={`dropdown-menu education-menu ${activeDropdown === 0 ? "active" : ""}`}>
                <div className="dropdown-content education-content">
                  {educationItems.map((item, index) => (
                    <div key={index} className="education-item-wrapper">
                      <a
                        href={item.link}
                        className="dropdown-item education-item"
                        onClick={(e) => toggleSubDropdown(index, e)}
                      >
                        <span className="education-icon">{item.icon}</span>
                        <span>{item.title}</span>
                        <span className="item-arrow">→</span>
                      </a>
                      {item.subItems && (
                        <div className={`sub-dropdown-menu ${activeSubDropdown === index ? "active" : ""}`}>
                          {item.subItems.map((subItem, subIndex) => (
                            <a
                              key={subIndex}
                              href={subItem.link}
                              className="sub-dropdown-item"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span>{subItem.title}</span>
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </li>
            <li className="dropdown-container">
              <a
                href="/country"
                onClick={(e) => toggleDropdown(1, e)}
                className={activeDropdown === 1 ? "active" : ""}
              >
                Study Abroad
                <span className="dropdown-arrow">→</span>
              </a>
              <div className={`dropdown-menu destinations-menu ${activeDropdown === 1 ? "active" : ""}`}>
                <div className="dropdown-content destinations-content">
                  {destinations.map((destination, index) => (
                    <a
                      key={index}
                      href={`/country/${destination?.id || destination.name.toLowerCase()}`}
                      className="dropdown-item destination-item"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <img
                        src={destination.icon || "/placeholder.svg"}
                        alt={`${destination.name} flag`}
                        className="flag-icon"
                      />
                      <span>{destination.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </li>
            <li className="dropdown-container services-dropdown">
              <a
                href="/services"
                onClick={(e) => toggleDropdown(2, e)}
                className={activeDropdown === 2 ? "active" : ""}
              >
                Other Services
                <span className="dropdown-arrow">→</span>
              </a>
              <div className={`dropdown-menu services-menu ${activeDropdown === 2 ? "active" : ""}`}>
                <div className="dropdown-content services-content">
                  {servicesItems.map((service, index) => (
                    <a
                      key={index}
                      href={service.link}
                      className="dropdown-item service-item"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span className="service-icon">{service.icon}</span>
                      <span>{service.title}</span>
                    </a>
                  ))}
                </div>
              </div>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
          <div className="start">
            <button
              className="btn btn-custom btn-lg page-scroll"
              onClick={openEnquiry}
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                cursor: "pointer",
                padding: 0,
              }}
            >
              <div className="button">GET STARTED</div>
            </button>
          </div>
          <button className="toggle" onClick={() => setClick(!click)}>
            {click ? <i className="fa fa-times"> </i> : <i className="fa fa-bars"></i>}
          </button>
        </nav>
      </header>

      {/* Login Modals */}
      <Login
        isLoginOpen={isLoginOpen}
        isSignupOpen={isSignupOpen}
        isForgotPasswordOpen={isForgotPasswordOpen}
        
        onCloseLogin={closeLogin}
        onCloseSignup={closeSignup}
        onCloseForgotPassword={closeForgotPassword}
       
        onOpenLogin={openLogin}
        onOpenSignup={openSignup}
        onOpenForgotPassword={openForgotPassword}
        onLoginSuccess={handleLoginSuccess}
      />
      <EnquiryModal
      isEnquiryOpen={isEnquiryOpen}
      onCloseEnquiry={closeEnquiry}
      />
    </>
  )
}

export default Header
